import API from 'lib/RemindAPI';
import { ActionTypes, AllClassesUnreadsKey } from 'constants/UnreadConstants';
import { dispatcher } from 'lib/Dispatcher';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import UNREADS from 'components/Navigation/Unreads.gql';
import { UnreadsQuery } from 'components/Navigation/__generated__/UnreadsQuery';

const UnreadActions = {
  async loadUnreads(): Promise<void> {
    const response = await API.request('/notifications/unread', 'GET');
    const { unreads, group_unreads: groupUnreads, organization_unreads: orgUnreads } = response;
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'u' implicitly has an 'any' type.
    const chatUnreads = unreads.find((u) => u.id === 'chats');
    const chatUnreadCount = chatUnreads ? chatUnreads.unread_count : 0;
    const orgUnreadCount = orgUnreads
      ? // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'u' implicitly has an 'any' type.
        orgUnreads.map((u) => u.unread_count).reduce((a, b) => a + b, 0)
      : 0;
    const allClassesUnreads = {
      id: AllClassesUnreadsKey,
      parent: '',
      unread_count: chatUnreadCount - orgUnreadCount,
    };

    // ATTENTION TRY TO AVOID THIS PATTERN IF POSSIBLE
    // the current unreads setup is rather complicated and complex and is using
    // both flux, backbone and graphql/apollo in ways that it usually gets uncordinated
    // This particular line attempts to make sure that we refresh the graphql side of unreads
    // whenever we are updating the flux side of unreads,
    // it is rather unefficient and eventually we would move everything to graphql anyways.
    // This is the same query that Navigation uses so we are effectively refreshing
    // the unread markers in the left navigation in the web UI
    getApolloClientSingleton().query<UnreadsQuery>({ query: UNREADS, fetchPolicy: 'network-only' });

    dispatcher.dispatch({
      type: ActionTypes.LIST_UNREADS,
      unreads: unreads.concat(groupUnreads || [], orgUnreads || [], allClassesUnreads),
    });
  },
  async clearThreadUnreads(threadUuid: string): Promise<void> {
    await API.request(`/notifications/threads/${threadUuid}`, 'DELETE');
    dispatcher.dispatch({
      type: ActionTypes.CLEAR_THREAD_UNREADS,
      threadUuid,
    });
  },
};

export default UnreadActions;
